export enum ProjectOperations {
  Add = "ADD",
  Edit = "EDIT",
}
